import invariant from 'react-utils/invariant';
const ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED'; // https://github.com/facebook/prop-types/blob/master/lib/ReactPropTypesSecret.js

/**
 * Run prop-types validations on given props and schema.
 * e.g.:
 *   check(
 *     { foo: 'fooValue', bar: ['barValue'] },
 *     { foo: PropTypes.string.isRequired, bar: PropTypes.array }
 *   );
 * @param object The props object to validate.
 * @param propTypes prop-type schema to validate against.
 * @throws Invariant Violation error if validation fails.
 */
export default function check(object, propTypes) {
  let propName;
  for (propName in propTypes) {
    if (Object.prototype.hasOwnProperty.call(propTypes, propName)) {
      const error = propTypes[propName](object, propName, JSON.stringify(object), 'prop', null, ReactPropTypesSecret);
      if (error) {
        invariant(false, error.message);
      }
    }
  }
}